import React from "react";
import { Box, Tooltip, Chip, Button, useMediaQuery } from "@mui/material";
import theme from "../../../style/theme";
import NotificationImportantRoundedIcon from "@mui/icons-material/NotificationImportantRounded";
import { ApplicationData } from "../ApplicationData";
import dayjs from "dayjs";

type ApplicationHeaderProps = {
  applicationData: ApplicationData;
};

/**
 * 申請詳細画面のヘッダーコンポーネント
 * - 申請番号・申請日・ステータス・急ぎフラグを表示する
 * - props: applicationData (申請データ)
 */
export const RecordDetailHeader: React.FC<ApplicationHeaderProps> = ({
  applicationData,
}) => {
  const isMobile = useMediaQuery("(max-width:600px)"); // 600px以下の場合はスマートフォンデバイス
  // 申請ステータスを日本語に変換するマッピング
  const statusMapping: { [key: string]: string } = {
    //申請ステータスの日本語マーピング
    NotStarted: "申請前",
    InProgress: "申請中",
    Completed: "完了",
    Canceled: "取り下げ",
    Failed: "却下",
    Error: "エラー終了",
    SendBack: "差し戻し",
    Draft: "一時保存",
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        gap: 1,
        mx: 3,
        mb: 4,
        flexDirection: isMobile ? "column" : "row",
      }}
    >
      {/* 申請番号 */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Chip label={`申請番号: ${applicationData.number}`} color="primary" />
        {dayjs(applicationData.submittedAt).isValid() && (
          <Chip
            label={`申請日：${dayjs(applicationData.submittedAt).format("YYYY/MM/DD")}`}
            variant="outlined"
            color="success"
          />
        )}
      </Box>

      {/* 右上の「状態」ラベル */}
      <Box sx={{ display: "flex", gap: 3 }}>
        <Box sx={{ borderRadius: 4, backgroundColor: "transparent" }}>
          {/* <Tooltip title="詳細状況を確認" arrow> */}
          <Button
            variant="outlined"
            disabled //クリック不可
            sx={{
              typography: "buttonMedium",
              color: theme.palette.common.black,
              borderColor: theme.palette.common.black,
              // "&:hover": { backgroundColor: theme.palette.grey[100] },
              "&.Mui-disabled": {
                color: theme.palette.common.black,
                borderColor: theme.palette.common.black,
                opacity: 1,
              },
            }}
          >
            ステータス：{" "}
            {statusMapping[applicationData.status ?? ""] ||
              applicationData.status ||
              "不明"}
          </Button>
          {/* </Tooltip> */}
        </Box>

        {/* 急ぎ申請マーク */}
        {applicationData.isExpress === true && (
          <Box sx={{ mt: 1, color: "orange" }}>
            <NotificationImportantRoundedIcon />
          </Box>
        )}
      </Box>
    </Box>
  );
};
